import {AbstractModel} from '../abstract-model';
import {Product} from '../product';

export class AvailableDomain extends AbstractModel {
  id!: number;
  domain!: string;
  slug: string | null = null;
  lang: string | null = null;
  product: Product | null = null;
  status: string | null = null;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    return this;
  }

  getSlug(): string {
    return this.slug ? `/${this.slug}/` : '/';
  }

  override toString(): string {
    return this.domain + this.getSlug();
  }
}
